"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _fluxActions = require("flux-actions");

var _interactionsActions = require("../../actions/interactionsActions");

var _UpdateSiteSettings = _interopRequireDefault(require("../../stagedObjects/UpdateSiteSettings"));

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var _constants = require("settings-ui-sdk/SiteSettings/constants");

var _handleActions;

var initialState = (0, _immutable.Map)({
  current: (0, _immutable.OrderedMap)(),
  staged: (0, _immutable.OrderedMap)()
});

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _interactionsActions.InteractionsActionTypes.ADD_ATTACHED_STYLESHEET, function (state, _ref) {
  var stylesheet = _ref.payload.stylesheet;
  return state.set('staged', state.get('staged').set(stylesheet.id, stylesheet.toJS()));
}), (0, _defineProperty2.default)(_handleActions, _interactionsActions.InteractionsActionTypes.REMOVE_ATTACHED_STYLESHEET, function (state, _ref2) {
  var id = _ref2.payload.id;
  return state.set('staged', state.get('staged').remove(id));
}), (0, _defineProperty2.default)(_handleActions, _interactionsActions.InteractionsActionTypes.REORDER_ATTACHED_STYLESHEETS, function (state, _ref3) {
  var stylesheets = _ref3.payload.stylesheets;
  return state.set('staged', stylesheets);
}), (0, _defineProperty2.default)(_handleActions, _interactionsActions.InteractionsActionTypes.TOGGLE_INHERIT_ATTACHED_STYLESHEET, function (state, _ref4) {
  var value = _ref4.payload.value;

  if (value === null) {
    return state.set('staged', value);
  }

  return state.set('staged', state.get('current') || (0, _immutable.OrderedMap)());
}), (0, _defineProperty2.default)(_handleActions, _UpdateSiteSettings.default.getStageForEditActionType(), function (_, _ref5) {
  var payload = _ref5.payload;
  var siteSettings = payload[_UrlPathParams.PAGES + "/SiteSettings"] || (0, _immutable.Map)();
  var attachedStylesheets = siteSettings.get(_constants.ATTACHED_STYLESHEETS);
  return (0, _immutable.Map)({
    current: attachedStylesheets,
    staged: attachedStylesheets
  });
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;